const state = {
  queryParams: {}, //history查询参数
  historyList: [],
  orderDetail: [],
  areaCode: '', //当前选择区code
  province: '', //当前选择省份
  firstProvince: '', //第一次选择省份
  cardType: '', //办卡类型
  appointType: '', // 预约类型，
  orderId: '', // 预约订单单号
  cardDetail: {}, // 修改卡对象
  resultData: [], // 提交订单结果
  driverList: [], //行驶证图片
  zkInfo: {} // 办个人多用户副卡时选择的主卡信息
}
const mutations = {
  SET_PARAMS(state, queryParams) {
    state.queryParams = queryParams
  },
  SET_HISTORYLIST(state, historyList) {
    state.historyList = historyList
  },
  SET_ORDERDETAIL(state, orderDetail) {
    state.orderDetail = orderDetail
  },
  SET_AREACODE(state, areaCode) {
    state.areaCode = areaCode
  },
  SET_PROVINCE(state, province) {
    state.province = province
  },
  SET_CARDTYPE(state, params) {
    state.cardType = params.cardType
    state.appointType = params.appointType
  },
  SET_FIRSTPROVINCE(state, firstProvince) {
    state.firstProvince = firstProvince
  },
  SET_ORDERID(state, orderId) {
    state.orderId = orderId
  },
  SET_DRIVERPHOTO(state, driverObj) {
    state.driverList[driverObj.index].photo1 = driverObj.photo1
    state.driverList[driverObj.index].photo2 = driverObj.photo2
  },
  SET_ZKINFO(state, zkInfo) {
    state.zkInfo = zkInfo
  },
  SET_DRIVERLIST(state, driverObj) {
    // type 0添加 1修改 2删除
    if (driverObj.type === 0) {
      state.driverList.push({
        busNo: driverObj.busNo,
        photo1: driverObj.photo1,
        photo2: driverObj.photo2,
        mobile: driverObj.mobile,
        identifyNO: driverObj.identifyNO
      })
    } else if (driverObj.type === 1) {
      if (driverObj.busNo != state.driverList[driverObj.index].busNo) {
        state.driverList[driverObj.index].photo1 = ''
        state.driverList[driverObj.index].photo2 = ''
      }
      state.driverList[driverObj.index].busNo = driverObj.busNo
      state.driverList[driverObj.index].mobile = driverObj.mobile
      state.driverList[driverObj.index].identifyNO = driverObj.identifyNO
    } else {
      state.driverList.splice(driverObj.index, 1)
    }
  },
  CLEAR_DRIVERLIST(state) {
    state.driverList = []
  },
  SET_CARDDETAIL(state, cardDetail) {
    state.cardDetail = cardDetail
  },
  SET_RESULTDATA(state, resultData) {
    state.resultData = resultData
  },
  CLEAR() {
    state.clearDrive = []
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
